(function(angular) {
    angular
        .module('repairforms.service.module')
        .service('DeviceDetectorService', DeviceDetectorService);

    DeviceDetectorService.$inject = ['deviceDetector', 'DEVICES', 'OS'];

    function DeviceDetectorService(deviceDetector, DEVICES, OS){
        return {
            isAndroid: isAndroid,
            isIOS : isIOS
        };

        function isAndroid(){
            return (deviceDetector.device === DEVICES.ANDROID || deviceDetector.OS === OS.ANDROID);
        }

        function isIOS(){
            return (deviceDetector.os === OS.IOS || deviceDetector.device === DEVICES.I_POD || deviceDetector.device === DEVICES.IPHONE);
        }

    };

})(angular);
